import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth, USER_ROLES } from '../../context/AuthContext';
import { fetchMentorById } from '../../services/mentorService';
import Layout from '../layout/Layout';
import './MentorDetail.css';
import './MentorProfile.css';

const MentorProfile = () => {
  const [mentor, setMentor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  const { currentUser, userRole, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const MAX_RETRIES = 3;
    const RETRY_DELAY = 2000; // 2秒後に再試行
    
    const getMentorProfile = async () => {
      if (!currentUser) return;
      
      try {
        console.log(`Attempting to fetch mentor profile (attempt ${retryCount + 1}/${MAX_RETRIES + 1})`);
        const mentorData = await fetchMentorById(currentUser.uid);
        setMentor(mentorData);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching mentor profile:', err);
        
        // 最大再試行回数に達していない場合は再試行
        if (retryCount < MAX_RETRIES) {
          console.log(`Retrying in ${RETRY_DELAY}ms...`);
          setTimeout(() => {
            setRetryCount(prev => prev + 1);
          }, RETRY_DELAY);
        } else {
          setError('OG情報の取得に失敗しました。');
          setLoading(false);
        }
      }
    };

    getMentorProfile();
  }, [currentUser, retryCount]);

  // OGデータがない場合はホームページにリダイレクト
  useEffect(() => {
    if (!loading && !mentor && userRole === USER_ROLES.MENTOR) {
      const redirectTimer = setTimeout(() => {
        console.log('Redirecting to home page due to missing mentor data');
        navigate('/');
      }, 5000); // 5秒後にリダイレクト
      
      return () => clearTimeout(redirectTimer);
    }
  }, [loading, mentor, navigate, userRole]);

  if (loading) return <div className="loading">読み込み中...</div>;
  if (error) return (
    <div className="error">
      <p>{error}</p>
      <button onClick={() => logout().then(() => navigate('/login'))}>ログアウト</button>
    </div>
  );
  if (!mentor) return (
    <div className="error">
      <p>OGが見つかりません。</p>
      <button onClick={() => logout().then(() => navigate('/login'))}>ログアウト</button>
    </div>
  );

  return (
    <Layout>
      <div className="profile-container">
        <h2 className="profile-heading">マイプロフィール</h2>
        <div id="mentor-detail">
          <div className="profile-header">
            <img 
              className="mentor-icon" 
              src={mentor.アイコンURL || "/image/mentor_icon.png"} 
              alt="OGのアイコン" 
            />
            <h1 className="mentor-name">{mentor.氏名}</h1>
          </div>
          <table>
            <colgroup>
              <col style={{ width: "25%" }} />
              <col style={{ width: "75%" }} />
            </colgroup>
            <tbody>
              <tr><th colSpan={2} id="section">プロフィール</th></tr>
              <tr><th>氏名</th><td className="mentor-name-table">{mentor.氏名}</td></tr>
              <tr><th>出身大学</th><td className="university">{mentor.出身大学}</td></tr>
              <tr><th>卒業年</th><td className="graduate">{mentor.卒業した年}</td></tr>
              <tr><th>連絡先</th><td className="contact">{mentor.連絡先}</td></tr>
              <tr><th colSpan={2} id="section">就職先情報</th></tr>
              <tr><th>業界</th><td className="industry">{mentor.就職先業界}</td></tr>
              <tr><th>会社名</th><td className="company">{mentor.会社名}</td></tr>
              <tr><th colSpan={2} id="section">学生の皆さんへ</th></tr>
              <tr><th>一言メッセージ</th><td className="message">{mentor.一言メッセージ}</td></tr>
            </tbody>
          </table>
        </div>
        
        <div className="profile-actions">
          <Link to="/mentor-profile/edit" className="edit-button">
            プロフィールを編集
          </Link>
        </div>
        
        <div className="navigation-buttons">
          <Link to="/mentors-list" className="nav-button">
            OG一覧を見る
          </Link>
          {userRole === USER_ROLES.MENTOR && (
            <Link to="/invite-mentor" className="nav-button">
              OGを招待する
            </Link>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default MentorProfile; 